export default "__VITE_ASSET__CbKExIHx__"